import { types } from 'mobx-state-tree';


const KITCHEN_TYPES = {
    ONE: 'one',
    TWO: 'two',
    THREE: 'three',
};

const KitchenTypeEnum = types.enumeration('KitchenType', Object.values(KITCHEN_TYPES));

export {
    KitchenTypeEnum,
};
export default KITCHEN_TYPES;
